import { useState } from 'react'

import { Button } from '@factorialco/deprecated-design-system'

import Modal from 'modules/core/components/Modal'
import i18n from 'modules/core/lib/i18n'

import RecurrentTypeSelector, { RecurrentType } from './RecurrentTypeSelector'

interface RecurrentTypeModalProps {
  onClose: () => void
  onSubmit: (value: RecurrentType) => void
}

const RecurrentTypeModal = ({ onClose, onSubmit }: RecurrentTypeModalProps) => {
  const [selectedRecurrentType, setSelectedRecurrentType] = useState<RecurrentType>('all')

  const onSelectRecurrentType = (value: RecurrentType) => {
    setSelectedRecurrentType(value)
  }

  return (
    <Modal
      onClose={onClose}
      illustration={'pencil'}
      title={i18n.t('project_management.schedule.recurrent_type_modal.title')}
      description={i18n.t('project_management.schedule.recurrent_type_modal.subtitle')}
      footer={
        <>
          <Button type="secondary" onClick={onClose}>
            {i18n.t('common.cancel')}
          </Button>
          <Button onClick={() => onSubmit(selectedRecurrentType)}>
            {i18n.t('common.continue')}
          </Button>
        </>
      }
    >
      <RecurrentTypeSelector
        onSelectRecurrentType={onSelectRecurrentType}
        recurrentType={selectedRecurrentType}
      />
    </Modal>
  )
}

export default RecurrentTypeModal
